import { Badge, BadgeProps, IconArrowDown, Text } from '@cmpsr/components';

type DecreasedRiskBadgeProps = {
  percentage?: string;
  isNonQuantifiable?: boolean;
} & BadgeProps;

export default function DecreasedRiskBadge({ percentage, isNonQuantifiable, ...props }: DecreasedRiskBadgeProps) {
  return (
    <Badge
      leadingIcon={isNonQuantifiable ? undefined : <IconArrowDown size="xs" />}
      justifyContent="center"
      height="22px"
      w={isNonQuantifiable ? '60px' : 'max-content'}
      py="2px"
      px="4px"
      backgroundColor="alert-success-default"
      borderRadius="radii-1"
      color="text-success"
      {...props}
    >
      <Text color="text-success" variant="text-body-floating-label-bold">
        {isNonQuantifiable ? <IconArrowDown size="xs" /> : percentage}
      </Text>
    </Badge>
  );
}
